export default "__VITE_ASSET__D9x9YSEI__"